/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * RU resource file
 */
export const labels = {
	title: "ЭЯ Канвас Экономика",
	status: "Cтатус",
	header: "Заголовок",
	canvas: "Канвас",
	canvasEconomics: "Экономические показатели Канвас",
	badRequest: "неверный запрос",
	errorBanner: "{0} Ошибка(и)",
	userProfileDropdown: {
		myProfile: "Мои данные",
		signOut: "Выйти"
	},
	clientCode: 'Client code',
	hours: "Кол-во часов",
	local: "Местная",
	currency: "Валюта",
	rate: "Курс",
	forecast: "Прогноз",
	variance: "Отклонение",
	edit: "Редактировать",
	arrowUp: "Стрелка ВВЕРХ",
	budget: "Бюджет",
	priorBudget: "Предыдущий бюджет",
	currentBudget: "Текущий бюджет",
	summary: "Сводная информация",
	actual: "Факт",
	priorActual: "Предыдущий факт",
	currentActual: "Текущий факт",
	remaining: "Остается",
	adjustment: "Корректировка",
	estimate: "Оценка",
	isRequired: "Необходимо указать {0}.",
	isPositiveInteger: "{0} является обязательным и должен быть целым числом без отрицательных значений.",
	isPositiveDecimal: "{0} является обязательным и должен быть положительным числом с 2 десятичными знаками.",
	in: "В",
	id: "Идентификатор",
	currentYear: "Текущий год",
	priorYear: "Предыдущий год",
	budgetHierarchy: "Иерархия бюджета",
	executionBudgetHierarchy: "Иерархия бюджета выполнения",
	noContentAvailable: "Содержание отсутствует",
	viewMore: "Показать дополнительные данные",
	budgetExecutionPhase: "Бюджет для всех объектов в пределах {0}",
	details: "подробная информация",
	unallocated: "Не распределено",
	none: "Отсутствует",
	thousands: "тысяч",
	millions: "млн.",
	lakhs: "сто тысяч",
	crores: "десять млн.",
	budgetObjectName: "Наименование объекта бюджета",
	editActivityCodes: "Редактировать коды деятельности",
	save: "Сохранить",
	cancel: "Отменить",
	searchActivityCodes: "Поиск кодов деятельности",
	noActivityCodesAvailable: "Нет доступных кодов деятельности",
	select: "Выберите",
	engagementCode: "Код задания",
	engagementCodeName: "Наименование кода задания",
	activityCode: "Код деятельности",
	activityCodeDescription: "Описание кода деятельности",
	searchActivityCodesPlaceholderText: "Поиск кодов деятельности",
	addMember: "Добавить участника",
	closeLabel: "Закрыть",
	cancelLabel: "Отменить",
	seachInputRequired: "Поиск необходимых входящих данных",
	nameOrEmail: "ФИО или электронный адрес",
	emailForExternal: "Адрес электронной почты",
	noRecord: "Результаты не найдены",
	userSearchPlaceholder: "Введите имя или электронный адрес и нажмите «Ввод» для вывода результатов.",
	userSearchPlaceholderForExternal: "Введите электронный адрес и нажмите «Ввод» для вывода результатов.",
	clearAllValues: "Сбросить все значения",
	clear: "Очистить",
	inValidEmail: "Введите действующий адрес электронной почты",
	invalidClientCode: "Неверный код клиента",
	railSearchText: "Поиск",
	open: "Открыто",
	remove: "Удалить",
	leave: "Покинуть",
	delete: "Удалить",
	markAsCompleted: "Отметить как завершенное",
	budgetedHours: "Забюджетированное кол-во часов",
	forecastedHours: "Прогнозируемые часы",
	actualHours: "Фактическое кол-во часов",
	ftaVariance: "Отклонение ПкФ",
	ftaVarianceTooltip: "Отклонение прогноза от факта",
	usedHours: "Потраченные часы",
	etcHours: "Оцениваемое кол-во часов для завершения",
	createProjectCard: "Создать проект",
	plusClients: "+{0} клиентов",
	plusCodes: "+{0} кодов клиента ",
	clientNames: "Название клиента: ",
	clientName: "Название клиента: ",
	clientNameLabel: "Наименование клиента",
	clientCodes: "Коды клиента: ",
	clientCodeCard: "Код клиента: ",
	financialAnalysis: 'Financial analysis',
	billingExpenses: "Выставление счетов и расходы",
	independence: 'Independence',
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel: 'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients: 'No associated client',
	noCanvasEngagementsIdentified: 'No EY Canvas engagements identified',
	placeholderForSearch: 'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: "Отображать данные по",
	financialDetails: "Финансовые данные",
	actualHoursToDate: "Фактическое количество часов на текущую дату",
	byWeekEndingDate: "по дате окончания недели",
	ClickAndDrag: "Нажмите и и перетащите область на диаграмме для увеличения",
	etc: "Оценочное время на выполнение",
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: "Задачи и основные этапы",
	milestonesOverdue: "Основные этапы просрочены",
	milestoneOverdue: "контрольные точки просрочены",
	inProgress: "В работе",
	inReview: "На стадии проверки",
	Complete: "Выполнено",
	assignments: "Назначения",
	assignment: "распределенные задания",
	assignmentsOverdue: "Просроченные распределенные задания",
	assignmentOverdue: "распределенные задания просрочены",
	overdue: "просрочены",
	requestOverdue: "Запрос просрочен",
	requestsOverdue: "запросы просрочены",
	total: "Итого",
	complete: "Выполнено",
	closed: "Закрыто",
	Unassigned: "Не назначено",
	unassigned: "не распределено",
	sent: "Отправлено",
	totalTask: "Итого задача",
	collaboration: "Взаимодействие",
	received: "Получено",
	accepted: "Принято",
	outstanding: "Не выполнено",
	unsentDrafts: "Неотправленные черновики",
	draft: "черновик",
	drafts: "черновики",
	returned: "возвращен",
	draftRequests: "черновики запросов",
	percent: "Процентное значение",
	preparer: "Исполнитель",
	reviewer: "Проверяющее лицо",
	NoDataForSelectedOptions: "По выбранным вариантам нет информации.",
	NoAssignmentDataForSelectedOptions: "В задании не используется функция назначения",
	NoCollabDataForSelectedOptions: "В задании не используется функция совместной работы",
	tasks: "Задачи",
	totalTasks: "итого задачи",
	requests: "запросы",
	requestSent: "запросы отправлены",
	requestsSent: "Запросы отправлены",
	expandDetails: "Развернуть подробную информацию",
	onlyProjectAdministratorsCanEdit: "Редактирование разрешено только администраторам проекта",
	onlyProjectAdministratorsCanDelete: "Удаление проектов разрешено только администраторам проекта",
	userOptions: "Параметры пользователя",
	userOptionsDropdown: {
		userSettings: "Пользовательские настройки",
		delegateAccess: "Управление уполномоченными лицами",
		privacyNotice: 'Privacy notice',
		signOut: 'Sign out'
	},
	delegateToInstruction: "Делегирование доступа коллегам, чтобы они могли осуществлять валидацию кодов задания от вашего имени. Эти уполномоченные лица получат доступ к валидации всех кодов задания, к которым у вас есть доступ.",
	delegateFromInstruction: "Следующим лицам были делегированы права валидации кодов задания.",
	delegateAccess: "Управление уполномоченными лицами",
	addDelegates: "Добавить уполномоченное лицо",
	addAnother: "Добавить новое уполномоченное лицо",
	hideMyDelegate: "Скрыть список моих уполномоченных лиц",
	showMyDelegate: "Показать список моих уполномоченных лиц",
	duplicateUser: "Уполномоченное лицо уже добавлено",
	informationRequired: "Обязательная информация",
	delegateTo: "Делегировано (кому)",
	delegateFrom: "Делегировано (кем)",
	noDelegatesAdded: "Уполномоченные лица не добавлены.",
	noDelegationReceived: "Делегирование не получено.",
	removeDelegateMessgae: "Удалить данное уполномоченное лицо? После удаления они больше не смогут осуществлять валидацию финансовых кодов задания от вашего имени.",
	removeDelegateTitle: "Удалить уполномоченное лицо",
	delegate: "Делегировать",
	saveAndClose: "Сохранить и закрыть",
	resetZoom: "Восстановить масштаб",
	exportData: "Экспорт данных",
	rankCode: "Код должности",
	userGui: "ГУИ пользователя",
	email: "Адрес электронной почты",
	globalAnsr: "Глобальная СЧСС",
	globalCost: "Глобальная себестоимость",
	globalMargin: "Глобальная маржа",
	localAnsr: "Местная СЧСС",
	localCost: "Местная себестоимость",
	localMargin: "Местная маржа",
	weekEnding: "Неделя, заканчивающаяся",
	welcomeToEconomics: "Добро пожаловать в ЭЯ Канвас Экономика ",
	adminPortal: 'administrative portal',
	home: "Главная страница",
	enterFirstNameText: "Введите имя, фамилию или адрес электронной почты пользователя и нажмите Ввод для поиска",
	addBtn: "Добавить",
	cancelBtn: "Отменить",
	selectRole: "Роль",
	upsText: "Упс!",
	sufficientRightsToAccess: "У вас нет достаточных прав доступа к данной странице",
	detailedInformation: "Подробная информация может отличаться от сводной из-за временных разниц, или если данные недоступны.",
	noResultFound: "Совпадений при поиске по критериям не найдено",
	loading: "Идет загрузка…",
	search: 'Search',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',

	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: 'Expand',
	collapse: 'Collapse',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
};

export const errors = {
	default: "Произошла ошибка. Свяжитесь со службой технической поддержки.",
	102: "Неверный проект",
	106: "Авторизация Контроля доступа на основании роли (РБАК) отклонена.",

	1001: "Пользователь не найден.",
	1002: "Запрос на поиск всех пользователей не выполнен.",
	1003: "ГУИ пользователя не может быть пустым.",
	1004: "Запрос не может быть пустым.",
	1005: "Не удалось создать пользователя, так как пользователь с таким же ГУИ уже существует.",
	1006: "Найдено несколько пользователей с одним и тем же ГУИ.",
	1007: "Пользователь неактивен. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1008: "Выбранный формат числа недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1009: "Выбранный формат округления недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1010: "Выбранный формат валюты недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1011: "Выбранный формат даты недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1012: "Выбранный язык недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1013: "Имя слишком короткое или слишком длинное. Повторите попытку.",
	1014: "Фамилия слишком короткая или слишком длинная. Повторите попытку.",
	1015: "Выбранный формат отрицательного числа недопустим. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1016: "Не удалось обновить пользователя, так как он не существует.",
	1017: "В ходе добавления предпочтений пользователя произошла ошибка. Ошибка вызова интерфейса программирования приложений.",
	1018: "В ходе создания пользователя произошла ошибка. Ошибка вызова интерфейса программирования приложений.",
	1019: "В ходе обновления предпочтений пользователя произошла ошибка. Ошибка вызова интерфейса программирования приложений.",
	1020: "Пользователь неактивен. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	1021: "Выбранное значение темы недопустимо. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1022: "Выбранное значение валюты недопустимо. Обновите страницу и повторите попытку. Если ошибку не удалось устранить, обратитесь в службу технической поддержки.",
	1023: "Пользователь не авторизован удалять запрашиваемого члена команды из проекта.",
	1024: "При создании уполномоченного лица произошла ошибка. Ошибка вызова интерфейса программирования приложений.",
	1025: "Список уполномоченных пользователей не должен быть пустым.",
	1026: "Имя пользователя\ слишком длинное или слишком короткое.",
	1027: "ГУИ пользователя\ недопустим.",
	1028: "Адрес электронной почты пользователя\ слишком длинный или слишком короткий.",
	1029: "Идентификатор пользователя не должен быть пустым.",
	1030: "Имя пользователя не должно быть пустым.",
	1031: "Адрес электронной почты пользователя не должен быть пустым.",
	1032: "Пользователь не входит в группу уполномоченных удалять доступ.",
	1033: "Пользователь не входит в группу делегирующих право удалять доступ.",
	1034: "Пользователь уже входит в группу уполномоченных лиц.",
	1035: "Длина идентификатора пользователя недопустима. Повторите попытку, используя корректный идентификатор пользователя.",
	1036: "Подключенный пользователь не может входить в список. Повторите попытку позже.",
	1040: "У вас нет прав администратора Обратитесь в службу технической поддержки.",

	7001: "Ошибка вызова метаданных задания.",
	7006: "ЭЯ Канвас в настоящий момент не доступен. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",

	8003: "Ошибка при получении сведений о задании из интерфейса программирования приложений СиДиЭс.",
	8006: "ЭЯ Канвас в настоящий момент не доступен. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.",
	8004: "Код задания не найден. Это код системы «Меркурий», убедитесь, что введен тип задания.  Повторите попытку и, если проблему не удается устранить, обратитесь в службу технической поддержки.",
	8007: 'Error while getting Engagement Details from CDS API.',

	9001: "Запрос не может быть пустым",
	9002: "Поле кода клиента по проекту не может быть пустым",
	9003: "Поле наименования проекта не может быть пустым.",
	9004: "Поле процентного значения не может быть пустым.",
	9005: "Поле рейтинга не может быть пустым.",
	9006: "Ни одно выбранное задание не привязано к бюджету.",
	9007: "Необходимо указать уникальный идентификатор задания.",
	9008: "Необходимо указать наименование клиента по заданию.",
	9009: "Необходимо представить описание задания. ",
	9010: "Необходимо указать уникальный идентификатор клиента по заданию.",
	9011: "Необходимо указать систему связанного задания.",
	9012: "Необходимо указать уникальный идентификатор связанного задания.",
	9013: "Необходимо указать наименование связанного задания.",
	9014: "Необходимо указать уникальный идентификатор клиента по связанному заданию.",
	9015: "Необходимо указать наименование клиента по связанному заданию.",
	9016: "Необходимо указать лицо, добавившее связанное задание.",
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: "Один или несколько связанных кодов задания недопустимы.",
	9019: "Процентное значение проектов должно быть больше нуля.",
	9020: "Процентное значение проектов не должно содержать более двух десятичных знаков.",
	9021: "Рейтинг проектов должен быть больше нуля.",
	9022: "Неверный идентификатор проекта.",
	9023: 'Get call for financial analysis failed.',
	9024: "Подробная информация по проекту не найдена.",
	9025: "Не удалось получить заголовок.",
	9026: "Совпадений при поиске по критериям не найдено.",
	9027: "Неверный тип агрегирования.",
	9028: "Текущий пользователь не имеет доступа к проекту.",
	9029: "Подробная информация по выставлению счетов по проекту не найдена.",
	9030: "Финансовые фильтры проекта не найдены.",
	9031: "Имя пользователя слишком длинное или слишком короткое.",
	9032: "ГУИ пользователя недопустим.",
	9033: "Адрес электронной почты пользователя слишком длинный или слишком короткий.",
	9034: "Как минимум один член команды должен иметь роль администратора проекта.",
	9035: "Вы являетесь последним активным пользователем с полномочиями администратора проекта. Удалите проект, чтобы убрать его с главной страницы. Если вы не можете удалить проект, свяжитесь со службой технической поддержки.",
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: "Удалите несколько членов команды, поскольку их количество превышает {0}.",
	9038: "Удалите несколько кодов заданий, поскольку их количество превышает {0}.",
	9039: "Количество пользователей проекта должно быть больше нуля.",
	9040: "Не прошедшие валидацию финансовые коды не должны быть нулевыми или пустыми строками, а их длина не должна превышать 50 символов.",
	9041: "Идентификатор проекта не должен быть пустым.",
	9042: "Невозможно завершить удаление. Повторите попытку и, если ошибку не удается устранить, обратитесь в службу технической поддержки.",
	9043: "Текущий пользователь не имеет доступа к редактированию проекта.",
	9044: "Запрос на поиск финансовых данных проекта не выполнен.",
	9045: "Недопустимый статус проекта.",
	9046: "Недопустимый статус пользователя проекта.",
	9047: "Недопустимая роль пользователя проекта.",
	9048: "Наименование проекта должно быть в пределах 500 символов.",
	9049: "Имя пользователя проекта не может быть пустым значением.",
	9050: "Фамилия пользователя проекта не может быть пустым значением.",
	9051: "ГУИ пользователя не может быть пустым значением.",
	9052: "Адрес электронной почты пользователя проекта не может быть пустым значением.",
	9053: "Признак администратора у пользователя проекта не может быть пустым значением.",
	9054: "Учетную запись с привилегированными правами нельзя добавить в качестве пользователя проекта.",
	9068: 'Some user already updated the status, refresh the page to view the latest status.',

	/*Admin error codes*/
	14001: "Пользователь не найден",
	14002: "Не удалось найти пользователя с правами администратора",
	14003: "Найденный администратор является активным пользователем",
	14004: "Не удалось создать пользователя с правами администратора",
	14005: "Имя слишком короткое или слишком длинное. Повторите попытку",
	14006: "Фамилия слишком короткая или слишком длинная. Повторите попытку",
	14007: "Идентификатор роли администратора недопустим",
	14008: "Выбранный пользователь уже является администратором Просьба проверить.",
	14009: "Запрос на поиск администратора не выполнен",
	14010: "ГУИ пользователя должен быть заполнен",
	14011: "Значение ГУИ пользователя должно быть больше нуля",
	14012: "Идентификатор пользователя недействителен Повторите попытку",
	14013: "Адрес электронной почты недействителен. Повторите попытку",
	14014: "Подключившийся пользователь не является администратором",
	14015: "Запрос на поиск администратора по проектам не выполнен",
	14016: "Администратор уже существует, но не является активным",
	14017: "Администратором может быть только учетная запись пользователя с привилегированными правами ",
	14018: "Идентификатор роли администратора не может быть пустым значением.",
	14019: "Подключившийся пользователь не является системным администратором.",
	14020: "Недопустимая учетная запись запрашивающего лица.",
	14021: "Администратором может быть только учетная запись пользователя с привилегированными правами.",
	14023: "Возникла ошибка при удалении существующих ролей администратора.",
	14024: "Возникла ошибка при добавлении обновленных ролей администратора.",
	14025: "Идентификатор пользователя с правами администратора не может быть пустым значением.",

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};

export const roundingOptions = [{
	value: 'none',
	label: "отсутствует"
},
{
	value: 'thousands',
	label: "В тысячах"
},
{
	value: 'millions',
	label: "В миллионах"
},
{
	value: 'lakhs',
	label: "В сотнях тысяч"
},
{
	value: 'crores',
	label: "В десятках миллионов"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "Английский",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "Французский",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "Испанский",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "Португальский",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "Японский",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "Китайский (КНР)",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "Китайский (Тайвань)",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "Иврит",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "Корейский",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "стильнумерации1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "стильнумерации3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "стильнумерации7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "стильнумерации2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "Глобальный уровень",
	label: "Глобальный уровень"
},
{
	value: "Местный уровень",
	label: "Местный уровень"
}
];

export const themeOptions = {
	light: "Светлый",
	dark: "Темный"
};

export const currencyOptions = {
	global: "Глобальный уровень",
	local: "Местный уровень"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "Глобальная организация"
},
{
	value: 'Local',
	label: "Местный уровень"
}
];

export const statusValues = [{
	isActive: true,
	label: "Активный"
},
{
	isActive: false,
	label: "Неактивный"
}
];

export const financialOptions = {
	serviceLine: 'Service line',
	subServiceLine: 'Sub-service line',
	teamMember: 'Team member',
	rank: 'Rank'
};

export const roles = {
	1: "Партнер, ответственный за задание",
	2: "Руководитель задания",
	3: "Исполнительный директор",
	4: "Принципал",
	5: "Старший менеджер",
	6: "Менеджер",
	7: "Эксперт",
	8: "Специалист",
	9: "Стажер",
	10: "Лицо, осуществляющее проверку качества выполнения задания",
	11: "Другой партнер",
	12: "Специалист ДжДС",
	13: "Консультационные услуги (управление ИТ и ИТ-рисками, консультационные услуги по сделкам, управление персоналом и др.)",
	14: "Налогообложение",
	15: "Административные услуги",
	16: "Руководитель юридической службы",
	17: "Контролер качества аудита",
	21: "Руководитель службы внутреннего аудита",
	22: "Специалист службы внутреннего аудита",
	23: "Регулирующий орган",
	24: "Прочее (напр., независимая комплексная проверка)",
	25: "Офис",
	26: "Межрегиональная область",
	27: "Отрасль",
	28: "Национальный уровень",
	29: "Глобальный уровень",
	30: "Эксперт ДжДС",
	31: "Менеджер ДжДС"
};

export const serviceLines = [{
	value: 0,
	label: "Все сервисные линии"
},
{
	value: 1,
	label: "Консультационные услуги"
},
{
	value: 2,
	label: "Аудит"
},
{
	value: 3,
	label: "РЮС"
},
{
	value: 4,
	label: "Консультационные услуги по сделкам"
},
{
	value: 5,
	label: "Налогообложение"
},
{
	value: 6,
	label: "Прочие"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "Не доступно"
},
{ 
	code: null,
	label: 'Allocation Allocation' 
},
{
	code: 'ASU',
	label: "Аудиторская практика"
},
{
	code: 'TAS',
	label: "Практика стратегии и сделок"
},
{
	code: 'TAX',
	label: "Налогообложение"
},
{
	code: 'ADV',
	label: "Консалтинг"
},
];

export const userRanks = [{
	id: '11',
	name: "Партнер"
},
{
	id: '12',
	name: "Партнер"
},
{
	id: '13',
	name: "Исполнительный директор"
},
{
	id: '21',
	name: "Старший менеджер"
},
{
	id: '32',
	name: "Менеджер"
},
{
	id: '36',
	name: "Менеджер отдела налогообложения"
},
{
	id: '4',
	name: "Подрядчик"
},
{
	id: '41',
	name: "Старший эксперт 3 года"
},
{
	id: '42',
	name: "Эксперт"
},
{
	id: '43',
	name: "Специалист 2 года"
},
{
	id: '44',
	name: "Специалист"
},
{
	id: '45',
	name: "Старший эксперт 2 года"
},
{
	id: '46',
	name: "Специалист 3 года"
},
{
	id: '49',
	name: "Специалист (админ)"
},
{
	id: '5',
	name: "Administrative contractor"
},
{
	id: '51',
	name: "Стажер"
},
{
	id: '52',
	name: "Административный помощник"
},
{
	id: '53',
	name: "Стажер (служба поддержки бизнеса)"
},
{
	id: '55',
	name: "Административный руководитель"
},
{
	id: '56',
	name: "Старший администратор"
},
{
	id: '57',
	name: "Администратор среднего уровня"
},
{
	id: '58',
	name: "Администратор начального уровня"
},
{
	id: '61',
	name: "Директор"
},
{
	id: '62',
	name: "Старший менеджер (админ)"
},
{
	id: '63',
	name: "Менеджер (админ)"
},
{
	id: '64',
	name: "Главный специалист"
},
{
	id: '65',
	name: "Старший специалист (админ)"
},
{
	id: '66',
	name: "Специалист (админ)"
},
{
	id: 'Not available',
	name: "Не доступно"
},
{ 
	id: null,
	name: 'Allocation Allocation' 
}
];

export const financialAnalysis = {
	noResultFound: "Результаты для выбранных вариантов не найдены",
	allServiceLines: "Все сервисные линии",
	allSubServiceLines: "Все направления сервисных линий",
	allMembers: "Все участники",
	allAvailable: "Все доступные",
	allAdded: "Все добавленные",
	selectAll: "Выбрать все",
	noResult: "Результаты не найдены",
	noneSelected: "Не выбрано",
	clearAllSeleted: "Очистить выбранный номер",
	showSelected: "Показать выбранные",
	allRanks: "Сотрудники всех должностей"
};

export const independenceStatus = [{
	value: 1,
	label: 'Incomplete - Not invited'
},
{
	value: 2,
	label: 'Incomplete - In progress'
},
{
	value: 3,
	label: 'Completed - Other'
},
{
	value: 4,
	label: 'Completed - Validated In EY Canvas'
}
];

export const employmentStatusFilter = [
	{ value: 'A', label: 'Active Active' },
	{ value: 'L,P,U', label: 'Leave of absence Leave of absence Leave of absence' },
	{ value: 'D,R,T', label: 'Terminated Terminated' }
]

export const employmentStatus = [
	{ value: 'A', label: 'Active Active' },
	{ value: 'D', label: 'Terminated Terminated' },
	{ value: 'L', label: 'Leave of absence Leave of absence' },
	{ value: 'T', label: 'Terminated Terminated' },
	{ value: 'P', label: 'Leave of absence Leave of absence' },
	{ value: 'R', label: 'Terminated Terminated' },
	{ value: 'U', label: 'Leave of absence Leave of absence' },
]

export const independenceStatusDropdown = [{
	label: 'Incomplete',
	options: [{
		value: 1,
		label: 'Incomplete - Not invited'
	},
	{
		value: 2,
		label: 'Incomplete - In progress'
	}
	]
},
{
	label: 'Complete',
	options: [{
		value: 3,
		label: 'Completed - Other'
	}]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: 'Member firm'
},
{
	id: 3,
	label: 'Country'
},
{
	id: 4,
	label: 'Hours charged'
},
{
	id: 5,
	label: 'Independence status'
},
{
	id: 6,
	label: 'Confirmation date'
},
{
	id: 7,
	label: 'Updated by'
},
{
	id: 8,
	label: 'Updated date'
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: 'Completed outside of EY Canvas'
},
{
	value: 2,
	label: 'Always a covered person'
},
{
	value: 3,
	label: 'No Longer with the Firm'
},
{
	value: 4,
	label: 'Other'
}
];

export const common = {
	selected: "Выбранные",
	cancel: "Отменить",
	checkbox: {
		selectAllOn: "Выбрать все",
		selectAllOff: "Отменить выбор для всех"
	},
	clear: "Очистить",
	close: "Закрыть",
	nav: {
		projectName: "Наименование проекта"
	},
	pagination: {
		show: "Показать",
		iconHover: {
			first: "Первая страница",
			previous: "Предыдущая страница",
			next: "Следующая страница",
			last: "Последняя страница"
		}
	},
	search: {
		clear: "Сбросить результаты поиска",
		buttonTitle: "Поиск",
		placeholder: "Поиск",
		noResultsPlaceholder: "Результаты не найдены"
	},
	table: {
		remove: "Удалить",
		noDataPlaceholder: "Данные отсутствуют",
		noResultsPlaceholder: "Результаты не найдены"
	},
	toggleSwitch: {
		no: "Нет",
		yes: "Да"
	},
	wizard: {
		next: "Продолжить",
		back: "Назад",
		finish: "Завершить"
	},
	unsavedChanges: "Несохраненные изменения",
	unsavedChangesDescription: "В случае продолжения работы все несохраненные изменения будут утрачены. Отменить сделанные изменения?"
};

export const eycanvasIndependenceStatusAvailableOnUI = [
	{ value: 1, label: 'Incomplete Incomplete' },
	{ value: 2, label: 'No Matters Identified No Matters Identified' },
	{ value: 3, label: 'Matter Identified - Pending Action Matter Identified - Pending Action' },
	{ value: 4, label: 'Matter Resolved - Denied Access Matter Resolved - Denied Access' },
	{ value: 5, label: 'Matter Resolved - Granted Access Matter Resolved - Granted Access' },
	{ value: 6, label: 'Not Applicable Not Applicable' },
	{ value: 7, label: 'Restored Restored' },
	{ value: 8, label: 'Override Override' },
	{ value: 9, label: 'Prior - No Matters Identified Prior - No Matters Identified' },
	{ value: 11, label: 'Prior - Matter Resolved - Granted Access Prior - Matter Resolved - Granted Access' },
	{ value: 12, label: 'Prior - Matter Resolved - Denied Access Prior - Matter Resolved - Denied Access' },
	{ value: 13, label: 'Not Invited Not Invited'}
];

export const project = {
	myProjects: "Мои проекты",
	priorProjects: "Предыдущие проекты",
	searchForBudgets: "Поиск",
	emptyContainer: "У вас нет активных бюджетов. Нажмите «Создать бюджет» для начала работы.",
	noResultsFound: "Результаты не найдены.",
	create: {
		title: "Создать проект",
		clientCode: "Код клиента",
		clientCodeInfo: "Зеркальные коды не распознаны. Используйте код из системы, выдающей код (т.е. Меркури или ДжФАЙС).",
		clientName: "Наименование клиента",
		clientNamePlaceholder: "Введите код клиента для поиска наименования клиента",
		name: "Наименование проекта",
		rate: "Почасовая ставка по умолчанию",
		rateInfo: "Почасовая ставка по умолчанию будет использоваться для расчета стоимости заложенных в бюджет часов. Эта ставка должна быть рассчитана как вознаграждение для целей выставления счетов, разделенное на общее ожидаемое время.",
		percentage: "Ожидаемый процент реализации",
		percentageInfo: "Ожидаемый процент реализации будет применен к стоимости списанного времени в часах в Меркури или ДжФАЙС.",
		relateEngagementsInstructionalText: "Выберите одно или несколько заданий ЭЯ Канвас, которые будут использоваться в этом проекте. Показатели, полученные по данным заданиям, будут представлены вместе с финансовыми данными. Будут отображаться только доступные в данный момент задания.",
		selectClientAndWorkspaceInstructionalText: "Выберите клиента и рабочее пространство для определения заданий ЭЯ Канвас, которые будут связаны с этим проектом.",
		engagementPanelPlaceholder: "Выберите клиента и рабочее пространство, чтобы отобразить предлагаемые задания.",
		engagementPanelNoResultsFound: "Результаты не найдены",
		emptyEngagements: "Нет доступных заданий ЭЯ Канвас. Для начала работы создайте новое задание ЭЯ Канвас.",
		selectClient: "Выбрать клиента",
		selectWorkspace: "Выбрать рабочее пространство",
		selectEngagements: "Выбрать задание",
		selectedEngagements: "Добавленные задания",
		selectedEngagementError: "Выбрать одну или несколько различных контрольных точек для продолжения",
		searchEngagements: "Поиск заданий",
		searchUsers: "Поиск пользователей",
		engagementLabel: "{0} | ИД: {1}",
		addBtn: "Добавить",
		removeBtn: "Удалить",
		clientLbl: "Клиент",
		engagementCodeLbl: "Код задания",
		engagementTypeCodeLbl: "Тип задания",
		engagementNameLbl: "Наименование задания",
		engagementId: "Идентификатор",
		addedByLbl: "Добавлено (кем)",
		engagementDescriptionLbl: "Описание задания",
		systemLbl: "Система",
		noEngagementsLabel: "Связать коды задания с этим проектом.",
		step4InstTxt: "Выбрать один или несколько кодов задания для привязки к проекту.",
		relatedEngagementCodesSubtitle: "Связанные коды задания",
		relatedEngagementCodeLink: "Связать код задания из Меркури или ДжФАЙС. Зеркальные коды не распознаны.",
		unauthorizedModalHeader: "Неавторизованный пользователь",
		unauthorizedText: "У вас нет прав связывать",
		allowedUsersText: "Ниже приведен список лиц, которые могут выполнять это действие.",
		closeBtn: "Закрыть",
		validateBtn: "Валидация",
		relatedEngagementAddLabel: "Связать код задания из Меркури или ДжФАЙС. Зеркальные коды не распознаны.",
		todayLbl: "Сегодня",
		NoEmailMessage: "Адрес электронной почты не предоставлен",
		noEngagementsAdded: "Не добавлено ни одного задания",
		selectToImport: "Выберите задание ЭЯ Канвас для импорта пользователей в этот проект.",
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: "Добавленные участники",
		employeeName: "Участник",
		role: "Роль",
		manageTeamInstructionalText: "Выберите активных членов команды из соответствующих заданий ЭЯ Канвас, следуйте описанию ниже, чтобы добавить других членов команды, не являющихся участниками заданий ЭЯ Канвас.",
		currentUser: "Текущий пользователь",
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [
			{
			stepName: "Этап 1",
			stepDescription: "Введите сведения о проекте",
			active: true
		},
		{
			stepName: "Этап 2",
			stepDescription: 'Select EY Canvas engagements'
		},
		{
			stepName: "Этап 3",
			stepDescription: "Управление доступом",
			relatedEngagementCodesSubtitle: "Связанные коды задания",
			relatedEngagementCodeLink: "Связать код задания из Меркури или ДжФАЙС. Зеркальные коды не распознаны.",
			unauthorizedModalHeader: "Неавторизованный пользователь",
			unauthorizedText: "У вас нет прав связывать",
			allowedUsersText: "Ниже приведен список лиц, которые могут выполнять это действие.",
			close: "Закрыть"
		},
		{
			stepName: "Этап 4",
			stepDescription: 'Connect to Mercury/GFIS'
		},
		{
			stepName: 'Step 5',
			stepDescription: 'Associate engagement codes to EY Canvas engagements',
			isExit: true
		}
		],
		ratePerHour: "Почасовая ставка",
		realizationPercentage: "Процент реализации"
	},
	stepOne: {
		enterProjectName: "Введите наименование проекта, чтобы продолжить"
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: "Результаты не обнаружены",
		clientName: "Клиент",
		workspace: "Рабочее пространство",
		engagementCode: "Код задания",
		canvasEngagementName: 'EY Canvas Engagement',
		changes: "Изменения",
		tooltipMessages: {
			clientName: "Наименование клиента",
			clientCode: "Код Клиента",
			engagementCode: "Код Задания",
			engagementDescription: "Наименование задания",
			workspaceID: "Идентификатор Рабочего Пространства",
			workspaceDescription: "Наименование Рабочего Пространства"
		}
	},
	stepThree: {
		editTeamMembers: "Редактировать членов команды на проекте",
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: "Добавить членов команды на проект",
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: "Результаты не обнаружены",
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: "Участник",
		projectAdministrator: "Администратор проекта",
		clickHere: "нажать сюда",
		nameOrEmail: "ФИО или электронный адрес",
		addNewMember: "Добавить",
		firstName: "Имя",
		lastName: "Фамилия",
		inviteAndClose: "Отправить приглашение и закрыть",
		inviteAndAddAnother: "Отправить приглашение и добавить следующего",
		clear: "Очистить"
	},
	stepFour: {
		engagementCode: "Код задания",
		clientName: "Клиент",
		validation: "Cтатус",
		independenceOnly: 'Independence only',
		noEngagementCodes: "Коды задания не добавлены в проект",
		addNewMember: "Добавить",
		addEngagementManually: "Добавить код задания",
		addEngagementCodes: "Добавить код задания",
		editEngagementCodes: "Редактировать коды задания",
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: "Для системы «Меркурий» введите тип задания в качестве префикса к коду задания (например, E-12345678)",
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: "Введите код задания",
		validate: "Валидация",
		engagementCodeRequired: "Требуется код задания",
		searchNoResults: "Результаты не найдены"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: 'No results found'
		},
		canvasEngagements: {
			searchButtonTitle: 'Search',
			clearButtonTitle: 'Clear',
			noResults: 'No results found',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
			displayUnassociatedEngagements: 'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: "Удалить проект",
	deleteDescription: "Удалить проект для всех пользователей?",
	deleteDescText: "Данная операция не может быть отменена.",
	delete: "Удалить",
	cancel: "Отменить",
	close: "Закрыть",
	confirm: "Подтвердить",
	leaveProject: "Покинуть",
	leaveDescription: "Покинуть данный проект? Он продолжит быть доступным для членов вашей команды.",
	change: "изменение",
	changes: "изменения"
};

export const users = {
	settings: {
		title: "Пользовательские настройки",
		firstName: "Имя",
		lastName: "Фамилия",
		displayLanguage: "Язык отображения",
		numberFormat: "Формат числа",
		negativeNumberFormat: "Формат отрицательного числа",
		currencyFormat: "Формат валюты",
		dateFormat: "Формат даты",
		roundingFormat: "Формат округления",
		save: "Сохранить",
		cancel: "Отменить",
		errorMessageSelect: "Выберите значение.",
		errorMessageInput: "Введите допустимое значение.",
		isRequired: " обязательно.",
		preferences: "Предпочтения",
		yourDelegates: "Ваши уполномоченные лица",
		yourDelegatesDescription: "Пользователи, которым вы предоставили полномочия на получение финансовых данных для кодов задания, к которым у вас есть доступ в Меркури или ДжФАЙС",
		delegationsFromOthers: "Делегирование от других лиц",
		delegationsFromOthersDescription: "Пользователи, которые вам предоставили полномочия на получение финансовых данных для кодов задания, к которым у них есть доступ в Меркури или ДжФАЙС",
		noUsersIdentified: "Пользователи не определены",
		addADelegate: "Добавьте уполномоченное лицо",
		theme: "Тема",
		preferredCurrency: "Предпочитаемая валюта",
		status: "Cтатус"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "Фильтр по клиентам",
		filter: "Фильтр",
		searchPlaceholder: "Поиск",
		searchClearHoverText: "Очистить",
		searchHoverText: "Искать",
		unvalidated: "Неутвержденный",
		noData: 'No EY Canvas engagement associated',
		noResults: "Результаты не найдены",
		noInformationAvailable: "Информация по выбранным вариантам отсутствует.",
		independence: 'Independence',
		noDataFound: 'No data found',
	},
	roundingType: "Округление: ",
	roundingFormats: {
		none: "Отсутствует",
		thousands: "в тысячах",
		millions: "в млн.",
		lakhs: "в сотнях тысяч",
		crores: "в десятках млн."
	},
	updatedDateType: {
		financialDateLabel: "Financial data",
		updatedOn: "updated on",
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "Общая выручка по заданию",
			actualTER: "Фактическая Общая выручка по заданию",
			billed: "Выставлено в счетах",
			actualBilling: "Фактические счета",
			totalEngagementRevenue: "Общая выручка по заданию (вознаграждение + расходы)",
			forecastedTER: "Прогнозируемая общая выручка по заданию"
		},
		margin: {
			margin: "Маржа",
			target: "Цель"
		},
		globalDeliveryService: {
			gds: "Использование услуг ДжДС",
			globalDeliveryService: "Глобальный обслуживающий центр"
		}
	},
	currency: "Валюта: ",
	globalCurrency: "Глобальная организация",
	localCurrency: "Местный уровень",
	noDataAvailable: "Нет данных для выбранных фильтров",
	actualHours: "Фактическое количество часов",
	etc: "и т.д.",
	ftaVariance: 'FTA variance',
	completedTasks: "Выполненные задачи",
	closedAssignments: "Закрытые распределенные задания",
	acceptedRequests: "Принятые запросы",
	gDSUsage: "Использование услуг ДжДС",
	summaryHeaderPartner: "Партнер",
	summaryHeaderPpedd: "ППИДД",
	summaryHeaderExecutive: "Руководящий сотрудник",
	financialProgressCard: {
		financialProgress: "Финансовые результаты",
		financialDetails: "Финансовые данные",
		ansr: "СЧСС",
		nsr: 'NSR',
		ansrTooltip: "Скорректированная чистая стандартная выручка (стоимость нетто услуг за вычетом расходов)",
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: "Затраты",
		hours: "Количество часов",
		expandDetails: "Развернуть подробную информацию",
		expand: "Развернуть",
		collapse: "Свернуть",
		collapseDetails: "Свернуть подробную информацию",
		margin: "Маржа",
		marginPercentage: "Маржа",
		rphAcronym: "Ставка/ч",
		cphAcronym: "Стоимость/ч",
		mphAcronym: "Маржа/ч",
		eafAcronym: 'EAF',
		actual: "Фактические",
		budgeted: "Заложенные в бюджет",
		forecasted: "Прогноз",
		ftaVariance: 'FTA variance',
		ftaVarianceTooltip: "Отклонение прогноза от факта",
		rph: "Почасовая ставка",
		cph: "Почасовая стоимость",
		mph: "Почасовая маржа",
		ansrCost: "ЧСС / Стоимость",
		serviceLine: 'Service line',
		subServiceLine: "Направление сервисной линии",
		teamMember: "Член команды",
		totalAnsr: "Итого ЧСС",
		totalCost: "Общая стоимость",
		totalHours: "Общее количество часов",
		ansrLabelText: 'Net standard revenue',
		rank: 'Rank',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: "Показать",
		first: "Первая",
		last: "Последняя",
		previous: "Назад",
		next: "Вперед"
	},
	financialFilters: {
		serviceLine: 'Service line',
		subServiceLine: "Направление сервисной линии",
		rank: 'Rank',
		teamMember: "Член команды",
		showMore: "Больше",
		clear: "Очистить",
		clearAll: "Очистить все",
		search: "Поиск",
		noResultsPlaceholder: "Результаты отсутствуют",
		noFiltersAvailable: "Фильтры отсутствуют",
		yes: "Да",
		no: "Нет",
		tooltip: "Фильтр",
		expenseType: 'Expense type',
        	allocation: "Allocation Allocation",
	},
	billingAndExpenses: {
		title: "Фактически выставленные счета на текущую дату",
		forecastedTer: "Прогнозируемая общая выручка по заданию",
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: "Прогнозируемые счета",
		collected: "Получено",
		collectedTooltip: 'Collected / Billed',
		unCollected: "Задолженность",
		unCollectedTooltip: 'Uncollected / Billed',
		billed: "Счета выставлены (не оплачены)",
		billedTooltip: 'Billed / Forecasted TER',
		billedTotal: "Выставлено в счетах",
		unbilled: "Не выставлено в счетах",
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: "Код задания",
		invoiceDate: "Дата счета",
		currency: 'Currency',
		invoiceNumber: "Номер счета",
		amount: "Сумма",
		noInformationPlaceholder: "Информация по выбранным вариантам отсутствует.",
		actualTer: "Фактическая Общая выручка по заданию",
		actualTerTooltip: "Общая сумма фактической выручки по заданию (стоимость услуг + расходы)",
		actualExpenseToDate: "Фактические расходы на текущую дату",
		displayBy: 'Display data by',
		expenseType: 'Expense type',
		teamMember: "Член команды",
		totalExpenseToDate: "Итого расходов на текущую дату",
		expenseTypeColumn: "Тип расходов",
		teamMemberColumn: 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: 'Service line',
		serviceLineColumn: 'Service line',
		rank: 'Rank',
		rankColumn: 'Rank',
		allocation: 'Allocation Allocation',
		allocationsExpense: 'Allocated expenses present Allocated expenses present',
	},
	independence: {
		teamMember: "Член команды",
		hoursCharged: 'Hours charged',
		independenceStatus: 'Independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status EY Canvas independence status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
		confirmationDateBefore: 'Confirmation date before',
		confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		location: 'Location Location',
		employeeStatus: 'Employee status Employee status',
		noResultsPlaceholder: 'No results found No results found',
		filter: {
			unassociatedFinancialCodes: 'Unassociated financial codes',
			unassociatedLabel: 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header: {
		hours: "Количество часов",
		actualHours: "Факт",
		forecastedHours: "Прогноз",
		variance: 'FTA variance',
		other: "Прочее",
		ppedd: "ППИДД",
		mgrSrMgr: "Ст менеджер/менеджер",
		partnerHours: "Часы партнера",
		executiveDirector: "Исполнительный директор",
		seniorManager: "Старший менеджер",
		manager: "Менеджер",
		senior: "Эксперт",
		staff: "Специалист",
		intern: "Стажер",
		billed: "Выставлено в счетах:",
		ter: "Общая выручка по заданию:",
		forecastedTER: "Прогнозируемая общая выручка по заданию:",
		margin: "Маржа",
		ansr: "СЧСС",
		cost: "Затраты",
		terSection: "Выручка",
		billedSection: "Выставлено",
		forecastedTERSection: "Прогноз",
		forecastedTERSectionForHeader: "Прогнозная выручка",
		completedTasks: "Выполненные задачи",
		completedAssignments: "Закрытые распределенные задания",
		acceptedRequests: "Принятые запросы",
		gdsUsage: "Использование услуг ДжДС",
		completedTasksTooltip: "Выполнено",
		totalTasksTooltip: "Итого",
		completedAssignmentsTooltip: "Закрыто",
		totalAssignmentsTooltip: "Итого",
		acceptedRequestsTooltip: "Принято",
		sentRequestsTooltip: "Отправлено",
		gdsHoursTooltip: "ДжДС",
		actualHoursTooltip: "Фактическое кол-во часов",
		otherTooltip: "Прочее",
		otherHeaderTooltip: "Прочее",
		ppeddTooltip: "ППИДД",
		mgrSrMgrTooltip: "Ст менеджер/менеджер",
		partnerHoursTooltip: "Партнер/Принципал",
		executiveDirectorTooltip: "Исп директор/директор",
		seniorManagerTooltip: "Старший менеджер",
		managerTooltip: "Менеджер",
		seniorTooltip: "Старший консультант",
		staffTooltip: "Специалист",
		internTooltip: "Стажер",
		varianceTooltip: "Отклонение прогноза от факта",
		ansrTooltip: "Скорректированная чистая стандартная выручка (стоимость нетто услуг за вычетом расходов)",
		marginTooltip: "Маржа= (СЧСС - стоимость) / СЧСС ",
		terSectionHover: "Общая сумма фактической выручки по заданию (стоимость услуг + расходы)",
		forecastedTERSectionHover: "Общая сумма прогнозируемой выручки по заданию (стоимость услуг + расходы)",
		billedSectionHover: "Чистая сумма фактически выставленных счетов",
		gdsUsageHover: "Использование Глобального обслуживающего центра"
	},
	allocationsFilters : [
		{
			value: 1,
			label: 'Yes Yes'
		}
	]
};

export const exportOptions = {
	buttonText: "Экспорт",
	downloadCSV: "Скачать файл в формате CSV",
	downloadJPEG: "Скачать изображение в формате JPEG",
	downloadPDF: "Скачать файл в формате PDF",
	downloadPNG: "Скачать изображение в формате PNG",
	downloadSVG: "Скачать файл в формате SVG",
	downloadXLS: "Скачать файл в формате XLS",
	exitFullscreen: "Выйти из полноэкранного режима",
	viewFullscreen: "Просмотр в полноэкранном режиме",
	printChart: "Распечатать диаграмму"
};

export const adminLabels = {
	adminPortal: "Администрирование",
	usersTab: "Управление пользователями",
	projectsTab: "Управление проектами",
	administrators: "Управление администраторами"
};

export const projectUserStatus = {
	active: "Активный",
	inactive: "Неактивный"
};

export const projectUserRoles = {
	defaultUser: "Пользователь по умолчанию",
	projectAdministrator: "Администратор проекта"
};

export const projectStatus = {
	active: "Активный",
	deleted: "Удаленный"
};

export const administratorRoles = {
	none: "Отсутствуют",
	adminReader: "Администратор с правами просмотра",
	adminWriter: "Администратор с правами редактирования",
	superAdmin: "Администратор с правами суперпользователя"
}

export const addUser = {
	firstName: "Имя",
	lastName: "Фамилия",
	enterFirstNameText: "Введите имя, фамилию или адрес электронной почты пользователя и нажмите Ввод для поиска",
	selectRole: "Роль",
	userRole: "Роль пользователя",
	clear: "Очистить",
	email: "Электронная почта",
	role: "Роль",
	cancel: "Отменить",
	addUser: "Добавить Пользователя",
	close: "Закрыть",
	add: "Добавить",
	addAdministrator: "Добавьте администратора",
	error1: "Выбранный пользователь уже является частью данного проекта. Просьба проверить.",
	error2: "Администратором может быть только учетная запись пользователя с привилегированными правами"
};

export const adminManageProjects = {
	manageProjects: "Управление проектами",
	description: "Поиск проекта по идентификатору проекта",
	projectId: "Идентификатор проекта",
	search: "Поиск",
	clearSearch: "Очистить",
	enterValidProject: "Ввести действительный идентификатор проекта",
	projectDetails: "Подробная информация о проекте",
	enterProjectName: "Ввести наименование проекта",
	projectName: "Наименование проекта",
	projectStatus: "Статус проекта",
	financialCodes: "Финансовые коды",
	noFinancialCodes: "С данным проектом не связан ни один финансовый код задания",
	engagementCode: "Код задания",
	client: "Клиент",
	status: "Cтатус",
	validatedBy: "Подтверждено (кем)",
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: "Участники",
	gui: "ГУИ",
	firstName: "Имя",
	lastName: "Фамилия",
	emailAddress: "Адрес электронной почты",
	userRole: "Роль пользователя",
	validated: "Подтверждено",
	unvalidated: "Не подтверждено",
	enterValidGui: "Введите действительный ГУИ для идентификатора проекта",
	requiredProjectName: "Необходимо заполнить наименование проекта",
	successToastMessage: "Изменения успешно сохранены",
	resetToastMessage: "Сброс выполнен",
	errorToastMessage: "Как минимум один член проекта должен быть администратором проекта. Проверьте изменения."
};

export const manageAdministrators = {
	title: "Управление администраторами",
	firstName: "Имя",
	lastName: "Фамилия",
	email: "Электронная почта",
	role: "Роль",
	description: "Добавление нового администратора или управление существующими администраторами",
	noInformationPlaceholder: "Информация по выбранным вариантам отсутствует.",
	updateAdminErrorToast: "Обновление не выполнено. Проверьте и повторите попытку позже.",
	updateAdminSuccessToast: "Изменения успешно сохранены",
};

export const adminManageUsers = {
	title: "Управление пользователями",
	description: "Поиск пользователя путем ввода его пользовательского ГУИ",
	inputLabel: "ГУИ пользователя",
	searchButtonLabel: "Поиск",
	cancelButtonLabel: "Очистить",
	errorMessage: "Введите действительный ГУИ пользователя",
	userDetails: "Информация о пользователе",
	projects: "Заложенные в проектах",
	delegates: "Уполномоченные лица",
	settings: "Настройки",
	noResultsPlaceholder: "Записей не обнаружено",
	delegatedTo: "Делегировано (кому):",
	delegatedFrom: "Делегировано (кем):",
	gui: "ГУИ",
	firstName: "Имя",
	lastName: "Фамилия",
	emailAddress: "Адрес электронной почты",
	projectName: "Наименование проекта",
	projectId: "Идентификатор проекта"
};

export const adminCommon = {
	save: "Сохранить",
	reset: "Сброс"
}
